module.exports = __webpack_public_path__ + "static/media/huihan-liu-card-1.07546084.jpg";